import ProcessingDialog from '@/components/dialog/processingDialog.vue'

export default {
  methods: {
    // Display a processing dialog designed for processes that require some time to process
    displayProcessingDialog(options, modalParams = {}) {
      this.displayModal(ProcessingDialog, options, null, modalParams).then(() => {})
    }
  }
}